import { getOfficePath, initElementTimestamp, getUserPath, nullishFilter, formatFullName, formatDateOfBirth } from '@caresend/utils';
import { getPatientsOnOffice } from '../../../database/algoliaConfig/methods.js';
import 'vue';
import 'lodash.isequal';
import '../../../router/helpers/initRouter.js';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import { useUserRole } from '../../../composables/user.js';
import 'firebase/auth';
import { getAlgoliaAPIKeyForPatientsOnOfficeRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/firebaseConfig/init.js';
import { dbGroupSet, getValueOnce } from '../../../database/firebaseConfig/methods.js';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';

const initLabResultsRecipients = (prescriberID) => ({
    faxNumbers: [],
    prescriberID,
    userIDs: [],
});
const loadOfficePatientsAction = async ({ commit, state }, { officeID }) => {
    const office = state.offices[officeID];
    if (!office)
        return;
    const { isNurse, isUnauthed } = useUserRole();
    if (isUnauthed.value)
        return;
    const { patients } = office;
    let patientsOnOffice = [];
    /**
      * Fallback to fetching patients from Algolia if patients haven't collected
      *
      * TODO: Remove this fallback once patients have been committed to offices
      * as a result of database script
      */
    if (!patients && !isNurse.value) {
        const securedApiKeyResponse = await getAlgoliaAPIKeyForPatientsOnOfficeRequest({
            officeID,
        });
        patientsOnOffice = await getPatientsOnOffice(securedApiKeyResponse.key);
        /** Initialize patient records on the office; this will only need to happen once */
        const patientOfficeSyncUpdates = patientsOnOffice.map(({ id }) => [
            getOfficePath(officeID, `patients/${id}`),
            initElementTimestamp(id),
        ]);
        dbGroupSet(Object.fromEntries(patientOfficeSyncUpdates));
    }
    else if (patients) {
        const patientPromises = (Object.keys(patients).map(async (patientID) => {
            const patient = await getValueOnce(getUserPath(patientID));
            return patient;
        }));
        const patientsResponses = await Promise.all(patientPromises);
        patientsOnOffice = patientsResponses.filter(nullishFilter);
    }
    const patientOptions = patientsOnOffice.map((patient) => {
        if (!patient.info)
            return;
        const name = formatFullName(patient);
        const dateOfBirth = patient.info.dateOfBirth
            ? formatDateOfBirth(patient.info.dateOfBirth)
            : 'Scheduling contact';
        return {
            caresFor: patient.caresFor,
            careTeam: patient.careTeam,
            id: patient.id,
            label: `${name} • ${dateOfBirth}`,
            info: patient.info,
        };
    }).filter(nullishFilter);
    commit('offices/SET_OFFICE_PATIENT_OPTIONS', { officeID, patientOptions });
    commit('users/SET_USERS', patientsOnOffice);
};

export { initLabResultsRecipients, loadOfficePatientsAction };
